import {
  Box,
  Flex,
  Select,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Button,
  Stack,
  Spinner,
  Badge,
  useColorModeValue,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Grid,
  GridItem,
  Icon,
  Avatar,
} from "@chakra-ui/react";
import { FaSync, FaPrint, FaClock, FaBook } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import AddBook from "../allocated_Teacher/BookList/Add_book";
import BookList from "../allocated_Teacher/BookList/BookList";
import Category from "./Category";
//   import Print_pdf_classDetails from "./Print_pdf_classDetails";

const Library = () => {
  return (
    <Box maxWidth="100%">
      <div className="teacher-list-container">
        <div
          className="header"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h1 style={{ fontSize: "20px", marginLeft: 10 }}>Book List</h1>
          <div className="action-buttons" style={{ marginLeft: "auto" }}>
            <div className="export-dropdown">
              <Flex gap={2}>
                <Category />
                <AddBook />
              </Flex>
            </div>
          </div>
        </div>

        <Box className="breadcrumb" pl={3}>
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Library </span> /
          {/* <Link
            to="/class/classlist"
            style={{ textDecoration: "none", color: "inherit" }}
          > */}
          <span>Book List</span>
          {/* </Link> */}
        </Box>
      </div>
      <Box
      // p={5}
      p={{base:"2",md:"5"}}
      >
        <BookList />
      </Box>
    </Box>
  );
};

export default Library;
